export const sessionClient = {
  readSession: (): boolean => {
    const raw = getCookieValue("auth_cookie_expires");
    if (!raw) {
      return false;
    }
    const expiresDate = new Date(raw);
    return expiresDate >= new Date();
  },
};

function getCookieValue(name: string) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`);
  const match = document.cookie.match(regex);
  if (match) {
    return match[2];
  }
}
